import { type NodeRenderer } from '@contentful/rich-text-react-renderer'
import {
  AssetOptionsContext,
  type AssetOptionsContextProps,
} from '@contexts/asset-options'
import BoxWithDimensionsProvider from '@contexts/box-with-dimensions-provider'
import { Entry } from '@resolvers/entry'
import React from 'react'

import { type EntryMapper, type References } from './types'

const assetOptions: AssetOptionsContextProps = {
  width: '100%',
  height: 'auto',
  minSvgWidth: '100%',
  maxSvgHeight: '100%',
  objectFit: 'contain',
  alt: '',
}

export const embeddedAsset =
  (references: References, mapping: EntryMapper): NodeRenderer =>
  (node) => {
    const entry = references.get(node.data.target.sys.id)
    if (!entry) {
      return null
    }

    const isTypeVideo = entry.file.contentType === 'video/mp4'

    return (
      <AssetOptionsContext.Provider value={assetOptions}>
        <div className="p-2">
          {isTypeVideo ? (
            <BoxWithDimensionsProvider>
              <Entry content={entry} mapping={mapping} />
            </BoxWithDimensionsProvider>
          ) : (
            <Entry content={entry} mapping={mapping} />
          )}
        </div>
      </AssetOptionsContext.Provider>
    )
  }
